// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__22axl","titleContainer":"styles_titleContainer__bkt8Z","lineContainer":"styles_lineContainer__1z2bh","separator":"styles_separator__3i-sL"};